/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ published: NonNullable<unknown>, draft: NonNullable<unknown> }} Cmspostcategory_Counts2Inputs */

const vi_cmspostcategory_counts2 = /** @type {(inputs: Cmspostcategory_Counts2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.published} đã đăng · ${i?.draft} nháp`)
};

/**

* @param {Cmspostcategory_Counts2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_counts2 = /** @type {((inputs: Cmspostcategory_Counts2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Counts2Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_counts2(inputs)
});
export { cmspostcategory_counts2 as "cmsPostCategory_counts" }